import React, { Component } from 'react'
import ThemePicker from './ThemePicker'
import '../styles/BookingContainer.css'
import DatePicker from './DatePicker'
import ThemeCalendar from './ThemeCalendar'
import AllThemesCalendar from './AllThemesCalendar'
import ThemesCart from './ThemesCart'
import LearnMoreButton from './LearnMoreButton'
import PopIn from './PopIn'
import PopInVBNCustom from './PopInVBNCustom'
import PlayersPicker from './PlayersPicker'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import moment from 'moment'
import 'moment/locale/fr'
import FAQPattern from '../images/FAQ/FAQpattern.png'
import { API_ROOT } from '../api-config'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import smoothscroll from 'smoothscroll'
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed'
import LAIconSmall from '../images/Themes/icon-small-la.png'
import VBNIconSmall from '../images/Themes/icon-small-vbn.png'
import AbattoirIconSmall from '../images/Themes/icon-small-abattoir.png'
import YakuzaIconSmall from '../images/Themes/icon-small-yakuza.png'
import TombeauIconSmall from '../images/Themes/icon-small-tombeau.png'
import { Cookies } from 'react-cookie-banner'
import { injectIntl, defineMessages } from 'react-intl'
import { Link } from 'react-router-dom'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

const getweekDays = (date, lang) => {
  let aDate
  if (lang === "fr") {
    aDate = moment(date.startOf('week'))
  } else {
    aDate = moment(date.startOf('week')).add(1, 'days')
  }

  const weekDays = []
  weekDays.push(formatWeekDay(aDate, lang))

  for (let i = 0; i < 6; i++) {
    weekDays.push(formatWeekDay(aDate.add(1, 'days'), lang))
  }

  return weekDays
}

const formatWeekDay = (date, lang) => {
  const dayString = date.format('llll').split(" ")
  const dayArray = []

  if (lang === "fr") {
    for (let i = 0; i < 2; i++) {
      dayArray.push(dayString[i])
    }

    return dayArray.join(' ')
  } else {
    return `${dayString[0]} ${dayString[2].substring(0, dayString[2].length - 1)}`
  }
}

const formatDate = (date, lang) => {
  const arr = date.format('l').split('/')

  if (lang === "fr") {
    return `${arr[2]}-${arr[1]}-${arr[0]}`
  } else {
    return `${arr[2]}-${arr[0]}-${arr[1]}`
  }
}

const getWeek = (date) => {
  return date.isoWeek()
}

const getYear = (date) => {
  return date.format('l').split('/').slice(-1).join()
}

const formatRoom = (theme) => {
  switch (theme) {
    case 'la':
      return 27
    case 'vbn':
      return 28
    case 'abattoir':
      return 29
    case 'yakuza':
      return 31
    case 'tombeau':
      return 32
    default:
      break
  }
}

const invertFormatRoom = (code) => {
  switch (code) {
    case 27:
      return "la"
    case 28:
      return "vbn"
    case 29:
      return "abattoir"
    case 31:
      return "yakuza"
    case 32:
      return "tombeau"
    default:
      break
  }
}

const buildAPI_URL = (theme, date, lang) => {
  if (theme === "all") {
    const formattedDate = formatDate(date, lang)
    return `${API_ROOT}FrontGetCalendarCompany.php?id_company=30&date=${formattedDate}`
  } else {
    const formattedRoom = formatRoom(theme)
    const week = getWeek(date)
    // Was fetching wrong year when 1st week of year was beginning with a day of year n-1
    // Ex : Monday of 1st week was 2018/12/31
    const dayNumOfFirstDayOfYear = new Date(parseInt(getYear(date)) + 1, 0, 1).getDay();
    const year = (week == 1 && 1 != dayNumOfFirstDayOfYear) ? parseInt(getYear(date, 10)) + 1 : getYear(date)

    return `${API_ROOT}FrontGetCalendarRoom.php?id_room=${formattedRoom}&week=${week}&year=${year}`
  }
}

const createMoment = (date) => {
  let year, month, day

  year = date.split('-')[0]
  month = date.split('-')[1] - 1
  day = date.split('-')[2]

  return moment({
    y: year,
    M: month,
    d: day
  })
}

const createMomentFromEnglish = (date, lang) => {
  let year, month, day

  if (lang === "fr") {
    day = date.split('/')[0]
    month = date.split('/')[1] - 1
    year = date.split('/')[2]

    return moment({
      y: year,
      M: month,
      d: day
    })
  } else {
    day = date.split('/')[1]
    month = date.split('/')[0] - 1
    year = date.split('/')[2]
    return moment({
      y: year,
      M: month,
      d: day
    })
  }
}

const themeToImageConverter = (code) => {
  switch (code) {
    case 'la':
      return LAIconSmall
    case 'vbn':
      return VBNIconSmall
    case 'abattoir':
      return AbattoirIconSmall
    case 'yakuza':
      return YakuzaIconSmall
    case 'tombeau':
      return TombeauIconSmall
    default:
      break
  }
}

const encodeLanguage = (lang) => {
  switch (lang) {
    case "french":
      return "fr"
    case "english":
      return "en"
    default:
      break
  }
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

const getEnglishHour = (hour) => {
  switch (hour) {
    case "10":
      return "10"
    case "12":
      return "12"
    case "14":
      return "2"
    case "16":
      return "4"
    case "18":
      return "6"
    case "20":
      return "8"
    case "22":
      return "10"
    default:
      break
  }
}

const getEnglishHourAMPM = (hour) => {
  switch (hour) {
    case "10":
      return "AM"
    case "12":
    case "14":
    case "16":
    case "18":
    case "20":
    case "22":
      return "PM"
    default:
      break
  }
}

const buildAPI_URL_Order = (idReservation, tokenReservation) => {
  return `${API_ROOT}FrontGetOrderDetails.php?id_order=${idReservation}&token_order=${tokenReservation}`
}

class BookingContainer extends Component {
  constructor(props) {
    super(props)

    if (this.props.lang === "fr") {
      moment.locale('fr')
    } else {
      moment.locale('en')
    }

    const theme = this.props.theme ? this.props.theme : "all"

    this.state = {
      date: moment(new Date()),
      weekDays: getweekDays(moment(new Date()), this.props.lang),
      selectedTheme: theme,
      currentSlot: null,
      selectedSlots: [],
      bookings: [],
      slots: [],
      weekSlots: [],
      showPopIn: false,
      showPopInEdit: false,
      showPopInLimitBooking: false,
      bookingToEdit: null,
      bookingPlayersToEdit: 0,
      bookingPriceToEdit: 0,
      showPopInVBNCustom: false,
      players: 4,
      language: this.props.lang === "fr" ? "french" : "english",
      playersQuantityInfo: null,
      VBNOption: false,
      VBNOptionPrice: 0,
      priceType: null,
      totalPrice: 0,
      firstOrder: false,
      calendarKey: 1,
      loading: false
    }
  }

  changeDate = async (date) => {
    await this.setState({
        date: date
      })
    if (this.state.selectedTheme !== "all") {
      await this.setState({
        weekDays: getweekDays(date, this.props.lang)
      })
    }
    await this.buildSchedules(this.state.selectedTheme, this.state.date)
    smoothscroll(document.getElementById("booking-smoothscroll-level"))
  }

  changeTheme = async (theme) => {
    await this.setState({
      selectedTheme: theme
    })

    const date = this.state.date

    if (theme !== "all") {
      await this.setState({
        weekDays: getweekDays(date, this.props.lang)
      })
    } else {
      await this.setState({
        date: moment()
      })
    }
    await this.buildSchedules(theme, this.state.date)
  }

  displayLanguage = (lang) => {
    switch(lang) {
      case "french":
        return "Français"
      case "english":
        return "English"
      default:
        break
    }
  }

  codeToThemeConverter = (theme) => {
    const {intl:{formatMessage}} = this.props

    switch (theme) {
      case formatMessage(messages.la):
        return "la"
      case formatMessage(messages.VBN):
        return "vbn"
      case formatMessage(messages.slaughterhouse):
        return "abattoir"
      case formatMessage(messages.yakuza):
        return "yakuza"
      case formatMessage(messages.tombeau):
        return "tombeau"
      default:
        break
    }
  }

  themeCodeConverter = (code) => {
    const {intl:{formatMessage}} = this.props

    switch (code) {
      case 'la':
        return formatMessage(messages.la)
      case 'vbn':
        return formatMessage(messages.VBN)
      case 'abattoir':
        return formatMessage(messages.slaughterhouse)
      case 'yakuza':
        return formatMessage(messages.yakuza)
      case 'tombeau':
        return formatMessage(messages.tombeau)
      default:
        break
    }
  }

  buildSchedules = async (theme, date) => {
    this.setState({loading: true});
    return await axios.get(buildAPI_URL(theme, date, this.props.lang))
      .then(response => {
        if (response.data.slots) {
          theme === "all"
            ? this.setState({ slots: response.data.slots})
            : this.setState({ weekSlots: response.data.slots})
        } else {
          theme === "all"
            ? this.setState({ slots: []})
            : this.setState({ weekSlots: []})
        }
        this.setState({loading: false});
      })
      .catch(error => console.log(error))
  }

  handleSelect = async (data) => {
    this.setState({ players: 4 })
    if (this.state.bookings.length > 5) {
      this.setState({ showPopInLimitBooking: true })
    } else if (!this.state.selectedSlots.includes(data)) {
      const room = data.split("|").shift()
      const playersQuantityInfo = await this.getPlayerByRoom(room)
      const priceType = await this.getPriceType(data)
      const totalPrice = await this.getTotalPrice(data, this.state.players, priceType)
      await this.setState({ currentSlot: data, playersQuantityInfo: playersQuantityInfo, priceType: priceType, totalPrice: totalPrice })
      this.togglePopIn()
    }
  }

  buildOrder = (data) => {
    let room, slot, date

    if (data.includes('|')) {
      room = data.split('|')[0]
      slot = data.split('|')[2]
      date = createMoment(data.split('|')[1])
    } else {
      room = data.split('-')[0]
      slot = data.split('-')[1]
      date = this.state.date
    }

    const players = this.state.players
    const language = this.state.language
    const price = this.state.totalPrice

    return {
      room: room,
      date: date,
      slot: slot,
      players: players,
      language: language,
      price: price
    }
  }

  getPlayerByRoom = async (room) => {
    const codeRoom = formatRoom(room)

    let response = await axios.get(`${API_ROOT}/FrontGetInfosRoomPricingByCompany.php?id_company=30`)
      .then(response => {
        const roomInfo = response.data.rooms.filter(x => x.id_room === codeRoom).shift()
        const roomPlayers = {
          min: roomInfo.quantity_player_min,
          max: roomInfo.quantity_player_max
        }
        return roomPlayers
      })
      .catch(error => console.log(error))

      return response
  }

  displaySlot = (slot) => {

    if (slot) {
      const slotInfo = slot.split("|")

      const room = this.themeCodeConverter(slotInfo[0])
      const date = createMoment(slotInfo[1]).format('l')
      const hour = slotInfo[2]
      const minutes = slotInfo[4]

      return {
        room: room,
        date: date,
        hour: hour,
        minutes: minutes,
        language: this.state.language
      }
    }
  }

  selectSlot = (data) => {
    const slot = this.buildOrder(data)

    if (!this.state.selectedSlots.includes(slot)) {
      this.setState({
        selectedSlots: [...this.state.selectedSlots, slot],
        currentSlot: null
      })
    }
  }

  slotToDelete = (slot) => {
    return {
      room: this.codeToThemeConverter(slot.room),
      slot: slot.hour,
      date: createMomentFromEnglish(slot.date)
    }
  }

  togglePopIn = () => {
    this.setState({ showPopIn: !this.state.showPopIn })
  }

  togglePopInVBNCustom = () => {
    this.setState({ showPopInVBNCustom: !this.state.showPopInVBNCustom })
  }

  scrollToLastBooking = () => {
    if (document.getElementById("booking-cta")) {
      setTimeout(() => {
        const bookingCTA = document.getElementById("booking-cta")

        scrollIntoViewIfNeeded(bookingCTA, {
          duration: 500,
          easing: 'easeIn'
        })
      }, 200)
    }
  }

  checkSlotSelected = (slot) => {
    return this.state.selectedSlots.filter(x => x.slot === slot.slot).length > 0
  }

  handleContinueBooking = async (slot) => {
    this.selectSlot(this.state.currentSlot)
    this.setState({ showPopIn: false })
    if (this.state.bookings.length > 0) {
      await this.addBookingToOrder(this.state.currentSlot)
    } else {
      await this.postCreateOrder(this.state.currentSlot)
    }
    this.updateBookings()
    this.buildSchedules(this.state.selectedTheme, this.state.date)
    this.scrollToLastBooking()
  }

  handleContinueBookingAfterEdit = async () => {
    this.editBooking()
    this.buildSchedules(this.state.selectedTheme, this.state.date)
    this.setState({ showPopInEdit: false })
  }

  editBooking = async () => {
    const url = `${API_ROOT}FrontEditRoomReservation.php`

    const idReservation = this.state.bookingToEdit.id
    const tokenReservation = this.findToken(parseInt(this.state.bookingToEdit.id, 10))
    const quantityPlayer = this.state.bookingPlayersToEdit
    const price = this.state.bookingPriceToEdit
    const lang = encodeLanguage(this.state.language)

    const body = {
      id_reservation: idReservation,
      token_reservation: tokenReservation,
      quantity_player: quantityPlayer,
      price: price,
      lang: lang
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const cookies = new Cookies()
      const bookings = data.order_details.rooms
      cookies.set('bookings', bookings, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      this.updateBookings()
    })
    .catch(error => console.log(error))
  }

  handleLanguage = (lang) => {
    this.setState({ language: lang })
  }

  getPricePerPlayer = (totalPrice, numberOfPlayers) => {
    return (totalPrice / numberOfPlayers).toFixed(2)
  }

  handleGoToCart = async (activeSlot) => {
    this.selectSlot(this.state.currentSlot)
    this.setState({ showPopIn: false })
    this.scrollToLastBooking()
    if (this.state.bookings.length > 0) {
      await this.addBookingToOrder(this.state.currentSlot)
    } else {
      this.setState({ firstOrder: true })
      await this.postCreateOrder(this.state.currentSlot)
    }
    await this.updateBookings()
    if (this.state.firstOrder) {
      this.props.history.push({
        pathname: "/cart",
        state: {
          new: true
        }
      })
      this.setState({ firstOrder: false })
    } else {
      this.props.history.push({
        pathname: "/cart"
      })
    }
  }

  handleGoToCartAfterEdit = async () => {
    await this.editBooking()
    this.props.history.push({
      pathname: "/cart"
    })
  }

  editCartItem = (slot) => {
    this.setState({
      bookingToEdit: slot,
      bookingPriceToEdit: slot.reservation_price_without_promo,
      bookingPlayersToEdit: parseInt(slot.quantity_player, 10),
      showPopInEdit: true
    })
  }

  deleteCartItem = async (slot) => {
    const idReservation = slot.id
    const idReservationToken = this.findToken(parseInt(slot.id, 10))

    const body = {
      id_reservation: idReservation,
      token_reservation: idReservationToken
    }
    const url = `${API_ROOT}FrontDeleteRoomReservation.php`

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const cookies = new Cookies()
      const bookings = cookies.get('bookings').filter(x => x.id !== slot.id)
      cookies.set('bookings', bookings, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      this.buildSchedules(this.state.selectedTheme, this.state.date)
      this.updateBookings()
      this.setState({ calendarKey: this.state.calendarKey + 1}) // To prevent a bug of slot not being bookable after deleted from cart
    })
    .catch(error => console.log(error))
  }

  handlePlayerQuantity = async (data) => {
    const players = data
    this.setState({ players: players })
    const totalPrice = await this.getTotalPrice(this.state.currentSlot, players, this.state.priceType)
    this.setState({ totalPrice: totalPrice })
  }

  handlePlayerQuantityEdit = async (data) => {
    const players = data
    const slot = `${invertFormatRoom(parseInt(this.state.bookingToEdit.room_id), 10)}|${this.state.bookingToEdit.reservation_date}|${this.state.bookingToEdit.time_begin.split(":").shift()}`
    const priceType = await this.getPriceType(slot)
    this.setState({ bookingPlayersToEdit: players, priceType: priceType })
    const totalPrice = await this.getTotalPrice(slot, players, this.state.priceType)
    this.setState({ bookingPriceToEdit: totalPrice



     })
  }

  getWeekDay = (date) => {
    const newDate = createMomentFromEnglish(date, this.props.lang)
    if (this.props.lang === "fr") {
      const lastIndex = newDate.format('LLLL').lastIndexOf(" ")
      return newDate.format('LLLL').substring(0, lastIndex)
    } else {
      return newDate.format('ll')
    }
  }

  buildPopinDate = (date, hour, minutes) => {
    if (this.props.lang === "fr") {
      return `${this.getWeekDay(date)} à ${hour}h${minutes}`
    } else {
      return `${this.getWeekDay(date)}, ${getEnglishHour(hour)}:${minutes} ${getEnglishHourAMPM(hour)}`
    }
  }

  getVBNOptionPrice = () => {
    axios.get(`${API_ROOT}/FrontGetInfosRoomPricingByCompany.php?id_company=30`)
      .then(response => {
        const price =  response.data.rooms.filter(x => x.id_room === 28).shift().options.shift().price
        this.setState({ VBNOptionPrice: price })
      })
      .catch(error => console.log(error))
  }

  getPriceType = async (slot) => {
    const room = formatRoom(slot.split("|")[0])
    const date = slot.split("|")[1]
    const hour = slot.split("|")[2]

    let response = await axios.get(`${API_ROOT}/FrontGetCalendarCompany.php?id_company=30&date=${date}`)
      .then(response => {
        const calendar = response.data.slots.filter(x => x.id_room === room.toString()).shift().calendar
        const priceType = calendar.filter(x => x.time_begin.startsWith(hour)).shift().global_price
        return priceType
      })
      .catch(error => console.log(error))

      return response
  }

  getTotalPrice = async (slot, playersQuantity, priceType) => {
    const room = formatRoom(slot.split("|")[0])
    let response = await axios.get(`${API_ROOT}/FrontGetInfosRoomPricingByCompany.php?id_company=30`)
      .then(response => {
        const priceKey = `price_h${priceType}`
        const price = response.data.rooms.filter(x => x.id_room === room).shift().prices.filter(x => x.quantity_player === playersQuantity.toString()).shift()
        return price[priceKey]
      })
      .catch(error => console.log(error))
      return response
  }

  postCreateOrder = async (slot) => {
    const url = `${API_ROOT}FrontCreateOrderWithReservation.php`

    const id_room_option = this.props.VBNOption ? "3" : ""
    const id_room_calendar = slot.split("|")[3]
    const date = slot.split("|")[1]
    const room = formatRoom(slot.split("|")[0])

    let lang = encodeLanguage(this.state.language);
    if (31 == parseInt(room)) {
      lang = encodeLanguage("french");
    }

    const body = {
      id_room_option: id_room_option,
      id_room_calendar: id_room_calendar,
      id_room: room,
      reservation_date: date,
      quantity_player: this.state.players,
      price: this.state.totalPrice,
      lang: lang
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(async (data) => {
      const cookies = new Cookies()
      const newBooking = data.order_details.rooms.filter(x => x.id === data.reservation_added.id_room_reservation.toString()).shift()
      const bookingsTokens = []
      const newBookingToken = {
        id_room_reservation: data.reservation_added.id_room_reservation,
        id_room_reservation_token: data.reservation_added.id_room_reservation_token
      }
      bookingsTokens.push(newBookingToken)
      const bookings = []
      bookings.push(newBooking)
      cookies.set('bookingsTokens', bookingsTokens, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      cookies.set('bookings', bookings, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      cookies.set('orderDetails', data, { path: '/', expires: new Date('2040-12-17T03:24:00') })

      if (cookies.get("vouchers")) {
        cookies.remove("vouchers")
      }

      if (cookies.get("orderDetailsVouchers")) {
        cookies.remove("orderDetailsVouchers")
      }
      await this.updateBookings()
      this.props.expiration()
    })
    .catch(error => {
      window.location.reload()
      console.log(error)
    })
  }

  findToken = (id) => {
    const cookies = new Cookies()
    return cookies.get("bookingsTokens").filter(x => x.id_room_reservation === id).shift().id_room_reservation_token
  }

  addBookingToOrder = async (slot) => {
    const url = `${API_ROOT}FrontAddReservationToOrder.php`

    const cookies = new Cookies()
    const orderCookie = cookies.get('orderDetails')
    const orderId = orderCookie.id_order_escape
    const orderToken = orderCookie.id_order_escape_token
    const id_room_option = this.props.VBNOption ? "3" : ""
    const id_room_calendar = slot.split("|")[3]
    const date = slot.split("|")[1]
    const room = formatRoom(slot.split("|")[0])

    let lang = encodeLanguage(this.state.language);
    if (31 == parseInt(room)) {
      lang = encodeLanguage("french");
    }


    const body = {
      id_order: orderId,
      token_order: orderToken,
      id_room_option: id_room_option,
      id_room_calendar: id_room_calendar,
      id_room: room,
      reservation_date: date,
      quantity_player: this.state.players,
      price: this.state.totalPrice,
      lang: lang
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const cookies = new Cookies()
      const newBooking = data.order_details.rooms.filter(x => x.id === data.reservation_added.id_room_reservation.toString()).shift()
      newBooking.id_room_reservation_token = data.reservation_added.id_room_reservation_token
      const bookings = this.state.bookings
      bookings.push(newBooking)
      const bookingsTokens = cookies.get("bookingsTokens")
      const newBookingToken = {
        id_room_reservation: data.reservation_added.id_room_reservation,
        id_room_reservation_token: data.reservation_added.id_room_reservation_token
      }
      bookingsTokens.push(newBookingToken)
      cookies.set('bookingsTokens', bookingsTokens, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      cookies.set('bookings', bookings, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      this.updateBookings()

    })
    .catch(error => {
      window.location.reload()
      console.log(error)
    })
  }

  updateBookings = async () => {
    this.setState({ bookings: [] })
    const bookings = []
    const cookies = new Cookies()
    if (Array.isArray(cookies.get('bookings'))) {
      cookies.get('bookings').forEach(reservation => {
        bookings.push(reservation)
      })
      this.setState({ bookings: bookings })
    }
  }

  updateNewBookings = (booking) => {
    const cookies = new Cookies()
    const bookings = booking.rooms
    cookies.set('bookings', bookings, { path: '/', expires: new Date('2040-12-17T03:24:00') })
    this.setState({ bookings: bookings })
  }

  updateOrder = async () => {
    const cookies = new Cookies()
    const idOrder = cookies.get("orderDetails").id_order_escape.toString()
    const tokenOrder = cookies.get("orderDetails").id_order_escape_token
    return await axios.get(buildAPI_URL_Order(idOrder, tokenOrder))
      .then(response => {
        console.log(response.data)
      })
      .catch(error => console.log(error))
  }

  checkUrlParams = () => {
    const search = window.location.search
    if (search) {
      let params = new URLSearchParams(search)
      this.setUrlParamsToState(params)
    }
  }

  setUrlParamsToState = async params => {
    const date = params.get('date')
    const time = params.get('time').split(':')[0]
    const roomId = invertFormatRoom(parseInt(params.get('roomId'), 10))

    if (date) {
      this.setState({ date: moment(new Date(date)) })
    }

    if (roomId) {
      this.setState({ selectedTheme: roomId })
    }

    if (date && time && roomId) {
      await this.buildSchedules(roomId, moment(new Date(date)))
      const cell = document.querySelector(`[id*="|${date}|${time}"]`)
      if (cell) {
        cell.click()
      }
    }
  }


  async componentDidMount() {
    // http://localhost:3000/reserver?date=2020-07-04&time=10:00:00&roomId=28
    this.checkUrlParams()

    await this.updateBookings()
    if (this.props.theme) {
      this.setState({
        selectedTheme: this.props.theme
      })
    }
    this.getVBNOptionPrice()
    this.buildSchedules(this.state.selectedTheme, this.state.date)
  }

  render() {
    const {intl:{formatMessage}} = this.props

    const activeSlot = this.displaySlot(this.state.currentSlot)

    const languageLabelStyle = this.state.language === ""
      ? "language-select-label"
      : "language-select-label langage-select-label--selected"

    const languageOptions = {
      frenchOnly: [
        { value: 'french', label: 'Français', className: 'language-select-option' }
        ],
      all: [
        { value: 'french', label: 'Français', className: 'language-select-option' },
        { value: 'english', label: 'English', className: 'language-select-option' },
      ]
    }

    return (
      <div className="booking-container">
        <div className="booking-rectangle">
          <div
            style={{backgroundImage: `url(${FAQPattern})`}}
            className="booking-rectangle-pattern"></div>
        </div>
        <div className={`booking-text-block ${this.props.noTitle ? "booking-text-block--padding" : ""}`}>
          {
            this.props.noTitle
            ? (
              <div
                className="booking-pricing booking-pricing--mobile"
                onClick={() => this.props.handleSidebar()}
                >
                <span>{formatMessage(messages.pricing)}</span><span className="question-mark--booking">?</span>
              </div>
            )
            : <h3>{formatMessage(messages.title)}</h3>
          }
          <p id="booking-smoothscroll-level">{formatMessage(messages.intro)}</p>
        </div>
        <ThemePicker
          selectedTheme={this.state.selectedTheme}
          handleChange={ theme => this.changeTheme(theme)}
        />
        <Select
          onFocus={(e) => document.getElementsByClassName("select-theme-mobile")[0].style.zIndex = 11}
          onBlur={(e) => document.getElementsByClassName("select-theme-mobile")[0].style.zIndex = 0 }
          name="theme"
          value={this.state.selectedTheme}
          onChange={(e) => this.changeTheme(e.value)}
          className={"language-select select-theme-mobile"}
          searchable={false}
          clearable={false}
          placeholder={""}
          options={[
            { value: 'all', label: 'Toutes les salles', className: 'language-select-option' },
            { value: 'la', label: 'Lost Asylum', className: 'language-select-option' },
            { value: 'vbn', label: 'Very Bad Night', className: 'language-select-option' },
            { value: 'abattoir', label: "L'abattoir", className: 'language-select-option' },
            // TODO : A décommenter pour Yakuza
            { value: 'yakuza', label: "Yakuza", className: 'language-select-option' },
			{ value: 'tombeau', label: "Expédition Maudite", className: 'language-select-option' }
          ]}
        />
        <DatePicker
          date={this.state.date}
          selectedTheme={this.state.selectedTheme}
          handleChange={ date => this.changeDate(date)}
          lang={this.props.lang}
          />

          <div className="calendar-container">
            {this.state.loading && (
              <div className="loader-overlay">
                <div className="loader"></div>
              </div>
            )}

            {this.state.selectedTheme === "all" && this.state.slots.length > 0 && (
              <AllThemesCalendar
                key={this.state.calendarKey}
                date={this.state.date}
                lang={this.props.lang}
                slots={this.state.slots}
                selectedSlots={this.state.bookings}
                handleClick={data => this.handleSelect(data)}
              />
            )}
            {this.state.selectedTheme !== "all" && this.state.weekSlots.length > 0 && (
              <ThemeCalendar
                date={this.state.date}
                theme={this.state.selectedTheme}
                lang={this.props.lang}
                weekDays={this.state.weekDays}
                slots={this.state.weekSlots}
                selectedSlots={this.state.bookings}
                handleClick={data => this.handleSelect(data)}
              />
            )}
          </div>

        {
          this.state.bookings.length > 0 && <p className="booking-themes-cart-title">{formatMessage(messages.selectedThemeTitle)} :</p>
        }

         {
            Object.keys(this.state.bookings).map((x, i) =>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionAppear={true}
                key={`transition-${i}`}
                transitionAppearTimeout={500}
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
              <ThemesCart
                key={i}
                slot={this.state.bookings[x]}
                lang={this.props.lang}
                editCartItem={slot => this.editCartItem(slot)}
                deleteCartItem={slot => this.deleteCartItem(slot)}
                VBNOptionPrice={this.state.VBNOptionPrice}
                togglePopInVBNCustom={() => this.togglePopInVBNCustom()}
                handleOption={(optionId, resaId, resaToken, hasOption) => this.toggleOption(optionId, resaId, resaToken, hasOption)}
                updateBookings={(booking) => this.updateNewBookings(booking)}
              />
              </ReactCSSTransitionGroup>

            )
         }
         {
          this.state.bookings.length > 0
            ?
              <Link to="/cart">
                <div id="booking-cta"><LearnMoreButton text={formatMessage(messages.book)} styleClass={"themes-cart-cta"}/></div>
              </Link>
            : null
         }
        {
          this.state.showPopInEdit
          ?
            <PopIn
              closePopIn={() => this.setState({ showPopInEdit: false })}
              small
              style={{padding: "0"}}
            >
              <div className="theme-popin">
                <div className="theme-popin-icon">
                  <img src={themeToImageConverter(invertFormatRoom(parseInt(this.state.bookingToEdit.room_id), 10))} alt=""/>
                </div>
                <h2>{this.state.bookingToEdit.room_name}</h2>
                <p className="theme-popin-date">{this.buildPopinDate(createMoment(this.state.bookingToEdit.reservation_date).format('l'), this.state.bookingToEdit.time_begin.split(":").shift(), this.state.bookingToEdit.time_begin.split(":")[1])}</p>
                <p className="theme-players-select-label">{formatMessage(messages.popinPlayerChoice)}</p>
                <span className="theme-players-minmax">{formatMessage(messages.popinPlayerMinMax, {max: 5})}</span>
                <PlayersPicker
                  players={this.state.bookingPlayersToEdit}
                  pickPlayers={(data) => this.handlePlayerQuantityEdit(data)}
                  playerMin={2}
                  playerMax={5}
                  />
                <p className="theme-language-select-label">{formatMessage(messages.popinLanguageChoice)}</p>
                <div className="theme-popin-select-language">
                  <Select
                    name="language"
                    value={this.state.bookingToEdit.room_id === "31" ? languageOptions.frenchOnly[0].value : this.state.language}
                    onChange={(e) => this.handleLanguage(e.value)}
                    className={"language-select"}
                    searchable={false}
                    clearable={false}
                    placeholder={""}
                    options={this.state.bookingToEdit.room_id === "31" ? languageOptions.frenchOnly : languageOptions.all}
                  />
                  <span className={languageLabelStyle}>{formatMessage(messages.popinLanguageLabel)}</span>
                </div>
                <h3><span>{Math.floor(this.getPricePerPlayer(this.state.bookingPriceToEdit, this.state.bookingPlayersToEdit ))},<sup>{(Math.round((this.getPricePerPlayer(this.state.totalPrice, this.state.players ) % 1) * 100) / 100).toFixed(2).split(".")[1]}</sup>€</span>/ PERS. {formatMessage(messages.popinTotalPrice)} {this.state.bookingPriceToEdit}€</h3>
                <div className="theme-popin-footer">
                  <div className="theme-popin-cta theme-popin-cta--blank" onClick={() => this.handleContinueBookingAfterEdit()}>{formatMessage(messages.popinBookAndContinue)}</div>
                  <div className="theme-popin-cta" onClick={() => this.handleGoToCartAfterEdit()}>{formatMessage(messages.popinBookAndPay)}</div>
                </div>
              </div>
            </PopIn>
          : null
        }
        {
          this.state.showPopIn
          ?
            <PopIn
              closePopIn={this.togglePopIn.bind(this)}
              small
              style={{padding: "0"}}
            >
              <div className="theme-popin">
                <div className="theme-popin-icon">
                  <img src={themeToImageConverter(this.codeToThemeConverter(activeSlot.room))} alt=""/>
                </div>
                <h2>{activeSlot.room}</h2>
                <p className="theme-popin-date">{this.buildPopinDate(activeSlot.date, activeSlot.hour, activeSlot.minutes)}</p>
                <p className="theme-players-select-label">{formatMessage(messages.popinPlayerChoice)}</p>
                <span className="theme-players-minmax">{formatMessage(messages.popinPlayerMinMax, {max: this.state.playersQuantityInfo.max})}</span>
                <PlayersPicker
                  players={this.state.players}
                  pickPlayers={(data) => this.handlePlayerQuantity(data)}
                  playerMin={this.state.playersQuantityInfo.min}
                  playerMax={this.state.playersQuantityInfo.max}
                  />
                <p className="theme-language-select-label">{formatMessage(messages.popinLanguageChoice)}</p>
                <div className="theme-popin-select-language">
                  <Select
                    name="language"
                    value={this.state.currentSlot.split("|")[0] === "yakuza" ? languageOptions.frenchOnly[0].value : this.state.language}
                    onChange={(e) => this.handleLanguage(e.value)}
                    className={"language-select"}
                    searchable={false}
                    clearable={false}
                    placeholder={""}
                    options={this.state.currentSlot.split("|")[0] === "yakuza" ? languageOptions.frenchOnly : languageOptions.all}
					//options={this.state.currentSlot.split("|")[0] === "tombeau" ? languageOptions.frenchOnly : languageOptions.all}
                  />
                  <span className={languageLabelStyle}>{formatMessage(messages.popinLanguageLabel)}</span>
                </div>
                <h3><span>{Math.floor(this.getPricePerPlayer(this.state.totalPrice, this.state.players ))},<sup>{(Math.round((this.getPricePerPlayer(this.state.totalPrice, this.state.players ) % 1) * 100) / 100).toFixed(2).split(".")[1]}</sup>€</span>/ PERS. {formatMessage(messages.popinTotalPrice)} {this.state.totalPrice}€</h3>
                <div className="theme-popin-footer">
                  <div className="theme-popin-cta theme-popin-cta--blank" onClick={() => this.handleContinueBooking(activeSlot)}>{formatMessage(messages.popinBookAndContinue)}</div>
                  <div className="theme-popin-cta" onClick={() => this.handleGoToCart(activeSlot)}>{formatMessage(messages.popinBookAndPay)}</div>
                </div>
              </div>
            </PopIn>
          : null
        }
        {
          this.state.showPopInVBNCustom
          ? <PopInVBNCustom closePopIn={() => this.togglePopInVBNCustom()} />
          : null
        }
        {
          this.state.showPopInLimitBooking
          ?
            <PopIn small klass="pop-in-limit" closePopIn={() => this.setState({ showPopInLimitBooking: false })}>
              <p>{formatMessage(messages.tooManyBookings)}</p>
            </PopIn>
          : null
        }
      </div>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'bookingContainer.title',
    defaultMessage: 'réservez :'
  },
  pricing: {
    id: 'booking.pricing',
    defaultMessage: 'Tarifs'
  },
  intro: {
    id: 'bookingContainer.intro',
    defaultMessage: 'Choisissez le(s) thème(s) et le(s) créneau(x) horaire de votre choix :'
  },
  book: {
    id: 'bookingContainer.book',
    defaultMessage: 'Réserver'
  },
  popinPlayerChoice: {
    id: 'bookingContainer.popinPlayerChoice',
    defaultMessage: "Choisissez le nombre de joueurs :"
  },
  popinPlayerMinMax: {
    id: 'bookingContainer.popinPlayerMinMax',
    defaultMessage: "(2 min. / {max} max.)"
  },
  popinLanguageChoice: {
    id: 'bookingContainer.popinLanguageChoice',
    defaultMessage: "Choisissez la langue :"
  },
  popinLanguageLabel: {
    id: 'bookingContainer.popinLanguageLabel',
    defaultMessage: "Langue :"
  },
  popinPricePerPlayer: {
    id: 'bookingContainer.popinPricePerPlayer',
    defaultMessage: "Prix par joueur :"
  },
  popinTotalPrice: {
    id: 'bookingContainer.popinTotalPrice',
    defaultMessage: "soit"
  },
  popinBookAndContinue: {
    id: 'bookingContainer.popinBookAndContinue',
    defaultMessage: "Ajouter une autre réservation"
  },
  popinBookAndPay: {
    id: 'bookingContainer.popinBookAndPay',
    defaultMessage: "Réserver et payer"
  },
  la: {
    id: 'themes.la',
    defaultMessage: 'Lost Asylum'
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: 'Very Bad Night'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Mission Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'expédition maudite"
  },
  selectedThemeTitle: {
    id: 'bookingContainer.selectedThemeTitle',
    defaultMessage: "Thème(s) choisi(s)"
  },
  tooManyBookings: {
    id: 'bookingContainer.tooManyBookings',
    defaultMessage: "Vous ne pouvez pas réserver plus de 6 créneaux !"
  },
})

export default withRouter(injectIntl(BookingContainer))




// WEBPACK FOOTER //
// ./src/components/BookingContainer.js